import * as React from "react";
import { GlobalConnectedProps, withVariableLookup } from "components/form/VariableLookup/VariableLookup";
import { default as Text, TextProps, DebounceText } from "primitiveComponents/form/Text/Text";

const TextWithInputRef = (props: TextProps & GlobalConnectedProps) => <DebounceText {...props} />;
export const VariableLookupText = withVariableLookup()(TextWithInputRef);
